/**
 * User Management REST client — `umRest/*` wraps Orval-generated calls in `libs/api-user-mgt/generated`.
 *
 * Implementation is split under `umRest/` by aggregate; this module is the public entrypoint.
 */
import { userManagementApprovalsSegment } from './umRest/approvalsSegment';
import { userManagementAccessReviewSegment } from './umRest/accessReviewSegment';
import { userManagementAuditSegment } from './umRest/auditSegment';
import { userManagementAuthSegment } from './umRest/authSegment';
import { userManagementContextSegment } from './umRest/contextSegment';
import { userManagementCatalogSegment } from './umRest/catalogSegment';
import { userManagementDelegationsSegment } from './umRest/delegationsSegment';
import { userManagementRolesSegment } from './umRest/rolesSegment';
import { userManagementSnapshotsSegment } from './umRest/snapshotsSegment';
import { userManagementToolAccessSegment } from './umRest/toolAccessSegment';
import { userManagementBulkUploadSegment } from './umRest/bulkUploadSegment';
import { userManagementUsersSegment } from './umRest/usersSegment';

export const userManagementApi = {
  ...userManagementUsersSegment,
  ...userManagementRolesSegment,
  ...userManagementCatalogSegment,
  ...userManagementApprovalsSegment,
  ...userManagementAuditSegment,
  ...userManagementAccessReviewSegment,
  ...userManagementSnapshotsSegment,
  ...userManagementContextSegment,
  ...userManagementAuthSegment,
  ...userManagementDelegationsSegment,
  ...userManagementToolAccessSegment,
  ...userManagementBulkUploadSegment
};

/** Port surface — same object as {@link userManagementApi}; use {@link getUserManagementGateway} from application. */
export type UserManagementGateway = typeof userManagementApi;
